import { SearchResultPage, StoreDetailPage } from "./pages";

export const storeRoutes = (): any => {
  return [
    {
      path: "/stores",
      Component: SearchResultPage,
    },
    {
      path: "/stores/:id",
      Component: StoreDetailPage,
    },
  ];
};
